import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Clock, ArrowRight } from "lucide-react";

export default function RecentlyViewed() {
  const [items, setItems] = useState([]);
  const [products, setProducts] = useState({});

  useEffect(() => {
    (async () => {
      const [rv, prods] = await Promise.all([api.get("/recently-viewed"), api.get("/peptides")]);
      setItems(rv.data);
      const m = {}; prods.data.forEach((p) => (m[p.slug] = p)); setProducts(m);
    })();
  }, []);

  return (
    <div data-testid="recently-viewed-page">
      <div className="mb-6">
        <div className="eyebrow mb-2">Recently Viewed</div>
        <h1 className="font-display text-3xl font-semibold text-slate-900 tracking-tight">Your recent browsing.</h1>
      </div>
      {items.length === 0 ? (
        <div className="border border-dashed border-slate-200 rounded-md p-12 text-center text-slate-500">
          <Clock className="w-8 h-8 text-slate-300 mx-auto mb-3" strokeWidth={1.5}/>
          Nothing here yet. Browse the <Link to="/catalog" className="text-blue-700">catalog</Link>.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((r) => {
            const p = products[r.peptide_slug];
            if (!p) return null;
            return (
              <Link key={p.slug} to={`/peptides/${p.slug}`} className="border border-slate-200 rounded-md p-5 bg-white card-clinical block">
                <div className="font-mono text-[10px] uppercase tracking-widest text-blue-700">{p.category}</div>
                <div className="mt-1 font-display text-lg font-semibold text-slate-900">{p.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">{p.chemical_name}</div>
                <div className="mt-4 pt-4 border-t border-slate-100 flex items-center justify-between text-xs">
                  <span className="text-slate-500">Viewed {new Date(r.viewed_at).toLocaleDateString()}</span>
                  <ArrowRight className="w-4 h-4 text-slate-300" strokeWidth={1.75}/>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
